(() => {
  'use strict';

  const VERSION = 'fitment-search-parts-first-v1';

  function movePartsFirst(root, tabsSelector, tabSelector) {
    const tabs = root.querySelector(tabsSelector);
    const partsTab = root.querySelector(`${tabSelector}[data-mode-tab="parts"]`);
    const vehicleTab = root.querySelector(`${tabSelector}[data-mode-tab="vehicle"]`);

    if (tabs && partsTab && vehicleTab && tabs.firstElementChild !== partsTab) {
      tabs.insertBefore(partsTab, vehicleTab);
    }

    return partsTab;
  }

  function initializeSharedSearch() {
    const root = document.getElementById('cap-home-fitment-search');
    if (!root || root.dataset.partsFirstReady === VERSION) return false;

    const partsTab = movePartsFirst(root, '.cap-home-fitment__tabs', '.cap-home-fitment__tab');
    if (!partsTab) return false;

    /* The shared Homepage/Cart script keeps its mode in a private state object.
       Triggering the real tab handler once keeps that state synchronized with
       the Parts-first markup instead of only changing the visual tab order. */
    partsTab.click();
    root.dataset.partsFirstReady = VERSION;
    return true;
  }

  function initializeFindPartsSearch() {
    const root = document.getElementById('cap-find-parts-app');
    if (!root || root.dataset.partsFirstReady === VERSION) return false;

    const partsTab = movePartsFirst(root, '.cap-find-parts__mode-tabs', '.cap-find-parts__mode-tab');
    if (!partsTab) return false;

    /* Preserve an explicit vehicle search coming from a URL such as
       /pages/find-parts?mode=vehicle, while keeping Parts as the normal default. */
    const hasExplicitMode = new URLSearchParams(window.location.search).has('mode');
    if (!hasExplicitMode && root.dataset.mode !== 'parts') partsTab.click();

    root.dataset.partsFirstReady = VERSION;
    return true;
  }

  function initialize() {
    if (initializeSharedSearch() || initializeFindPartsSearch()) return;

    let attempts = 0;
    const retry = () => {
      attempts += 1;
      if (initializeSharedSearch() || initializeFindPartsSearch() || attempts >= 240) return;
      window.requestAnimationFrame(retry);
    };
    window.requestAnimationFrame(retry);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
